import React, { useState } from "react";
import { Box, Button, Text, DateInput, TextInput } from "grommet";
import { FormClose } from "grommet-icons";
import {useLazyQuery,useMutation} from "@apollo/client";
import {DELETE_NOTIFICATION, USER_NOTIFICATION} from "./notificationGQL.js";

import { format, parse, startOfMonth, endOfMonth, isSameDay, isAfter, isBefore } from 'date-fns';

/**
 * Componente che implementa la lista di notificheà
 * Verrà poi inserita in Notifiche.js
 */
const NotificationApp = (props) => {

  const [text, setText] = React.useState('');
  const [notifications,setNotifications] = useState(props.notifications);
  const [deleteNotification]=useMutation(DELETE_NOTIFICATION);
  const [dataInizio, setDataInizio] = useState(format(startOfMonth(new Date()), "yyyy-MM-dd"));
  const [dataFine, setDataFine] = useState(format(endOfMonth(new Date()), "yyyy-MM-dd"));


    function displayNotifications() {
        let displayNotifications = props.notifications.filter((notification) => {
            const notificationDate = parse(notification.data, "yyyy-MM-dd", new Date());
            const startDate = parse(dataInizio, "yyyy-MM-dd", new Date());
            const endDate = parse(dataFine, "yyyy-MM-dd", new Date());

            return (isSameDay(notificationDate, startDate) || isAfter(notificationDate, startDate)) &&
                isBefore(notificationDate, endDate) &&
                (text === "" ||
                    notification.title.toLowerCase().includes(text.toLowerCase()) ||
                    notification.body.toLowerCase().includes(text.toLowerCase()));
        });
        setNotifications(displayNotifications);
    }


    React.useEffect(()=>{
    displayNotifications();
  },[props.notifications])

  /**
   * Funzione che cancella una notifica
   */
  function handleNotification(notificaid) {
      let res = window.confirm("Sei sicuro di voler eliminare la notifica?");
      if (res) {
          deleteNotification({ variables: { id: notificaid, read: true } })
              .then(() => alert("Notifica eliminata correttamente"))
              .catch((error) => {
                  alert("Errore durante la cancellazione");
                  console.error(error);
              });
          props.getNotification({ variables: { id: sessionStorage.getItem("userId") } });
      }
  }



  return (
    <Box width="90%" align="center">
      <Box direction="column" gap="small" pad="small" align="center" style={{backgroundColor: "#fafafa", boxShadow: "1px 1px 9px 0px rgb(0 0 0 / 31%)"}}>
        <Box direction="row" gap="medium" pad="small">
            <Box direction="row" gap="small" pad="small" align="center">
              <Text>INIZIO</Text>
              <DateInput
                format="dd/mm/yyyy"
                value={dataInizio}
                onChange={({ value }) => {
                    debugger;
                   setDataInizio(value)
                }}
                name="data_inizo"
                id="data_inizio"
              />
            </Box>
            <Box direction="row" gap="small" pad="small" align="center">
                <Text>FINE</Text>
                <DateInput
                  format="dd/mm/yyyy"
                  value={dataFine}
                  onChange={({ value }) => {
                      debugger;
                      setDataFine(value)
                  }}
                  name="data_fine"
                  id="data_fine"
                />
            </Box>
            <Box direction="row" gap="small" pad="small" align="center">
                <TextInput
                  style={{backgroundColor: "white"}}
                  placeholder="Ricerca testuale"
                  value={text}
                  onChange={event => setText(event.target.value)}
                />
            </Box>
            <Button
                style={{
                  width: "140px",
                  height: "60px",
                  background: 'rgb(248, 178, 14)',
                  color: 'white',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  padding: "5px",
                  borderRadius: "20px",
                  alignContent: "center"
                 }}
                onClick={() => displayNotifications()}
              >
                <center>
                Filtra
                </center>
            </Button>
        </Box>

      </Box>
        <Box overflow={"auto"} align={"center"} height={"80%"}>
                {
                notifications.map(notifica =>
                <Box
                  width="70%"
                  round
                  pad="small"
                  margin="1%"
                  direction="column"
                  background="#FAFAFABF"
                  style={{display: 'inline-table',borderStyle: 'solid',borderColor:'#707070',borderWidth:"1px"}}
                >
                  <Box  direction="row" justify="between" pad={{ vertical: "small" }} style={{display: 'table!important'}}>
                    <Box  direction="column" gap="small" pad={{ vertical: "small" }}>
                      {
                        notifica.data?
                        <Text
                        color="#000000"
                        size="large"
                        weight="bold"
                        margin={{ horizontal: "small" }}
                      >
                        {notifica.data+" - "+notifica.title}
                      </Text>
                      :
                      <Text
                      color="#000000"
                      size="large"
                      weight="bold"
                      margin={{ horizontal: "small" }}
                    >
                      {notifica.title}
                    </Text>
                      }
                      <Text size="medium" color="#000000" margin={{ horizontal: "small" }}>
                        {notifica.body}
                      </Text>
                    </Box>
                    <Box>
                      <Button plain icon={<FormClose color="#000000" />} onClick={() =>handleNotification(notifica.id)} />
                    </Box>
                  </Box>
                </Box>
                )
                }
        </Box>
  </Box>
  );
}

export default NotificationApp;